
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.75 10.222a5.472 5.472 0 1110.944 0 5.472 5.472 0 01-10.944 0zm5.472-6.972a6.972 6.972 0 104.372 12.404l4.876 4.876a.75.75 0 101.06-1.06l-4.876-4.876A6.972 6.972 0 0010.222 3.25z"}})])
          )
        }
      }
    